import { StrictMode } from 'react';
import { ApolloProvider } from '@apollo/client';
import { createRoot } from 'react-dom/client';

// entry component
import App from './App.tsx';

// graphql client
import client from './graphql/client';

// global styles
import './styles/global.css';
import { AuthProvider } from '@/components/Authenticate';

// Apollo provider
export const Apollo = ({ children }: { children: React.ReactNode }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Apollo>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Apollo>
  </StrictMode>
);
